<template>
  <div :class="['page', language === 'cn' ? 'font-cn' : 'font-en']">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescription(item.description_2)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_2" alt="Content Image" class="image" />
              </div>
              <div v-html="formattedDescription(item.description_3)" class="description"></div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/008/VRParkPageWallpaper.png"),
            image_2: require("@/assets/img/News/008/VRParkPageimg2.png"),
            title: "云翰虹章携手匈牙利VR Vidámpark团队，共拓中国VR主题公园市场",
            description_1:`
              自2024年4月12日来，云翰虹章团队与来自匈牙利的VR Vidámpark团队建立了紧密的合作关系，协助其在中国进行本地化进程，并致力于解决合作中出现的各种问题
            `,
            description_2:`
              VR Vidámpark团队专注于将文化旅游和最新的虚拟现实技术（VR）相结合，以VR主题公园的形式，为游客提供前所未有的沉浸式体验。凭借在VR领域的先进技术和丰富的实践经验，他们在欧洲取得了显著的成功，建立了中欧最大的VR主题乐园之一。

              鉴于中国拥有庞大的人口和巨大的潜在市场，VR Vidámpark团队看到了在中国建立VR主题公园的广阔前景。然而，初次进入中国市场并非一帆风顺，由于对中国的制度和文化缺乏了解，他们遭遇了种种挑战。在此背景下，云翰虹章团队与VR Vidámpark团队结缘，并建立了合作关系。
            `,
            description_3:`
              云翰虹章团队协助了VR Vidámpark团队与方特、赛创未来的合作项目，为该团队提供全方位的项目管理服务，包括售后管理、反馈收集、用户访谈、数据埋点与分析等。在我们的协助下，VR Vidámpark团队逐渐适应了中国市场。
              
              未来，云翰虹章团队将继续与VR Vidámpark团队携手，共同推动VR技术在中国文化旅游产业的发展，为更多游客带来独特的沉浸式体验。
            `,
            // description_no_1:`
            //   <strong class="bold-text">1. ...</strong>
            // `,
            // description_no_2: `
            //   <strong class="bold-text">2. ...</strong>
            // `,
            // description_no_3: `
            //   <strong class="bold-text">3. ...</strong>
            // `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/008/VRParkPageWallpaper.png"),
            image_2: require("@/assets/img/News/008/VRParkPageimg2.png"),
            title:
              "Rosy Nebula established cooperative relationship with VR Vidámpark team",
            description_1:`
              On April 12, 2024, Rosy Nebula established a cooperative relationship with the VR Vidámpark team from Hungary by assisting them in the localization process in China and committed to solving various problems arising from our cooperation.
            `,
            description_2:`
              VR Vidámpark focuses on continuing cultural tourism and VR technology. In addition, they provide immersive experiences for visitors by establishing VR theme parks. With advanced technology and extensive experience in the VR field, they have achieved significant success in Europe, establishing one of the largest VR theme parks in Central Europe.

              VR Vidámpark realized that China has a large population with an immense potential market, so they decided to build VR theme parks in China. However, they encountered some troubles because they lacked an understanding of Chinese culture and laws. On this basis, Rosy Nebula established a cooperative relationship with VR Vidámpark.
            `,
            description_3:`
              After that, Rosy Nebula assists VR Vidámparkteam in coordinating cooperative projects with Fangta and Saichuang Weilai by providing comprehensive project services, including after-sales management, feedback collection, user interviews, and data analysis. The VR Vidámpark team has gradually adapted to the Chinese market with our assistance.
               
              Rosy Nebula looks forward to continuing to work together with the VR Vidámpark team in the future, jointly promoting the development of VR technology in China's cultural tourism industry and bringing unique immersive experiences to more visitors.
            `,
            // description_no_1:`
            //   <strong class="bold-text">1. ...</strong>
            // `,
            // description_no_2: `
            //   <strong class="bold-text">2. ...</strong>
            // `,
            // description_no_3: `
            //   <strong class="bold-text">3. ...</strong>
            // `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
